export enum CompType {
  lease = 'lease',
  sale = 'sale',
  property = 'property',
  company = 'company',
  pricingQuote = 'pricingQuote',
  tenantInMarket = 'TIM',
}
